'use client';

import Link from 'next/link';
import { type FC, type ReactElement } from 'react';
import { ChevronRight } from '@eqi-investimentos/icons/web';
import { Flex, type FlexProps, Text } from '@eqi-investimentos/react';
import { Slider, type SliderProps } from '@eqi-investimentos/slider';
import { IfRender } from '@/utils/jsx';
import '@eqi-investimentos/slider/css';
export const WidgetContainer: FC<WidgetContainerProps> = ({
  children,
  containerId,
  buttonLink,
  buttonTitle = 'Ver tudo',
  containerProps,
  customTitle,
  containerTitleProps,
  darkMode = false,
  removeSeeAllButton = false,
  showTitles = true,
  title,
  sliderProps,
  containerSxProps = {
    '& .swiper-slide': {
      _last: {
        pr: '2xl'
      }
    },
    '& > div > div': {
      _first: {
        pr: '2xl'
      }
    }
  },
  customButtonTitle = null
}) => <Flex pos="relative" flexDir="column" w="full" h="full" gap="l" color="content.primary" {...containerProps} sx={{
  ...containerSxProps,
  ...(sliderProps?.displayControls === false && {
    [`.slide-prev-${containerId}`]: {
      display: 'none'
    },
    [`.slide-next-${containerId}`]: {
      display: 'none'
    }
  })
}} data-sentry-element="Flex" data-sentry-component="WidgetContainer" data-sentry-source-file="index.tsx">
    <IfRender condition={!!customTitle} data-sentry-element="IfRender" data-sentry-source-file="index.tsx">
      <Flex pos="absolute" top="0.375rem" alignItems="center" gap="5xl" zIndex="overlay" {...containerTitleProps} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        {customTitle}
      </Flex>
    </IfRender>

    <IfRender condition={showTitles} data-sentry-element="IfRender" data-sentry-source-file="index.tsx">
      <Flex pos="absolute" top="0.375rem" alignItems="center" gap="5xl" zIndex="overlay" {...containerTitleProps} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <Text aria-label="title-widget" size="2xl" data-sentry-element="Text" data-sentry-source-file="index.tsx">
          {title}
        </Text>

        <IfRender condition={!removeSeeAllButton && !!buttonLink} data-sentry-element="IfRender" data-sentry-source-file="index.tsx">
          <Link href={buttonLink!} passHref data-sentry-element="Link" data-sentry-source-file="index.tsx">
            <Text size="l" color="content.brand" data-sentry-element="Text" data-sentry-source-file="index.tsx">
              {buttonTitle}
              <ChevronRight boxSize="1.25rem" data-sentry-element="ChevronRight" data-sentry-source-file="index.tsx" />
            </Text>
          </Link>
        </IfRender>
        <IfRender condition={!!customButtonTitle} data-sentry-element="IfRender" data-sentry-source-file="index.tsx">{customButtonTitle}</IfRender>
      </Flex>
    </IfRender>
    <Slider id={containerId} controlsAlignment="top-right" displayControls displayProgress={false} slidesGap={20} swiperGap="20px" variant={darkMode ? 'dark' : 'light'} iconStyles={{
    borderColor: 'border.primary',
    color: 'content.brand',
    _disabled: {
      color: 'action.disabled'
    }
  }} {...sliderProps} data-sentry-element="Slider" data-sentry-source-file="index.tsx">
      {children}
    </Slider>
  </Flex>;
type WidgetContainerProps = {
  children: ReactElement[];
  containerId: SliderProps['id'];
  buttonLink?: string | null;
  buttonTitle?: string;
  containerProps?: Omit<FlexProps, 'sx'>;
  containerTitleProps?: Omit<FlexProps, 'sx'>;
  containerSxProps?: FlexProps['sx'];
  customTitle?: ReactElement;
  customButtonTitle?: ReactElement;
  darkMode?: boolean;
  removeSeeAllButton?: boolean;
  showTitles?: boolean;
  sliderProps?: Omit<SliderProps, 'children' | 'id' | 'iconStyles'>;
  title?: string;
};